module.exports = __webpack_public_path__ + "static/media/man_barrels_getty_tablet.6ab6e188.jpg";